"use client";

import { usePathname } from "next/navigation";

import JsonLd from "@/components/seo/JsonLd";
import { track } from "@/lib/analytics/track";
import { faqJsonLd } from "@/lib/seo/schema";

type FaqItem = { question: string; answer: string };

export default function OfferFaq({
  heading,
  items,
}: {
  heading: string;
  items: readonly FaqItem[];
}) {
  const pathname = usePathname();
  const questions = items.map((item) => ({ question: item.question, answer: item.answer }));

  return (
    <section className="sec" aria-labelledby="offer-faq-heading">
      <JsonLd data={faqJsonLd(questions)} />
      <div className="wrap stack g48">
        <h2 id="offer-faq-heading" className="h2 reveal">
          {heading}
        </h2>
        <div className="faq reveal">
          {items.map((item) => (
            <details
              key={item.question}
              onToggle={(event) => {
                if (!event.currentTarget.open) return;
                track("faq_open", {
                  page_path: pathname,
                  question: item.question.slice(0, 100),
                });
              }}
            >
              <summary>
                <h3 className="h4" style={{ margin: 0 }}>
                  {item.question}
                </h3>
              </summary>
              <p className="ans">{item.answer}</p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
